import { Component, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AnalyticsHelper } from 'src/app/helpers/analytics';
import { environment } from 'src/environments/environment';
import { AnalyticsQueries, SKUQueries } from 'src/app/model/constants';
import * as tsvParse from 'd3-dsv';
import { Router } from '@angular/router';
import { getChartStateFromUrl } from 'src/app/helpers/queryString';
const ALL_OBJ = { cd: 'All', name: 'All' };
// const Region_TranslationName = {
//   "FV統括部": "FV Management Department", "VMエリア営業本部": "VM Area Sales Headquarters",
//   "アルコール事業統括部": "Alcohol Business Division", "カスタマーデベロップメント本部": "Customer Development Division",
//   "九州/中四国営業本部": "Kyushu/Chu-Shikoku Sales Headquarters", "北関東/南東北営業本部": "North Kanto/South Tohoku Sales Headquarters",
//   "営業本部その他": "Sales Headquarters Others", "関西/中部営業本部": "Kansai/Chubu Sales Headquarters", "首都圏営業本部": "Metropolitan Area Sales Headquarters",
//   "FSエリア営業本部": "FS Area Sales Headquarters"
// }

@Component({
  selector: 'bapc-monthly',
  templateUrl: './bapc-monthly.component.html',
  styleUrls: ['./bapc-monthly.component.scss']
})

export class BapcMonthlyComponent implements OnChanges {
  @Output() ready = new EventEmitter<boolean>();
  @Input() selectedDate: any;
  @Input() monthlyData: any;
  bapcMonthlyTrendChart: ApexCharts;
  channels: any;
  monthlyTrendChannel: any;
  populated: boolean;
  salesArea = [ALL_OBJ];
  salesDistrict = [ALL_OBJ];
  aggregatedSalesArea = [ALL_OBJ];
  aggregatedSalesDistrict = [ALL_OBJ];
  salesAreaList = AnalyticsHelper.getRegions();
  salesAreaBinding = [];
  salesDistrictList = [];
  salesDistrictBinding = [];
  sales_area_to_sales_district = {};
  salesAreaDistrictData = {};
  districtCode = [];
  regionCode = [];
  channelLev3codetoRegioncode = {};
  chartId = "bapc-source-chart"
  availableYears: any;
  selectedYears: any;

  constructor(public datepipe: DatePipe,
    private http: HttpClient, private router: Router) { }

  // ngOnInit() {
  //   this.getDataInit();
  // }

  ngOnInit() {
    const chartState = getChartStateFromUrl(this.router, this.chartId);
    for (const key in chartState) {
      this[key] = chartState[key]
    }
  }

  async ngOnChanges() {
    //Init data
    if (!this.populated) {
      this.channels = [];
      this.channels.push(
        {
          name: 'All',
          level: 1
        });
      let channels = AnalyticsHelper.ChannelLv2();
      channels.push({
        code: [41, 51],
        channel: 'Alcohol',
        level: 1,
        region: ['7200', '9100']
      });
      for (var i = 0; i < channels.length; i++) {
        let channel = channels[i];
        if (channel.channel == 'Vending_FS' || channel.channel == 'Vending_REG') {
          continue;
        }
        this.channels.push({
          name: channel.channel,
          level: channel.level,
          code: channel.code
        })
      }
      this.monthlyTrendChannel = ['All'];
      this.availableYears = ['All'];
      this.populated = true;
    }
    //Bind data for charts
    if (this.monthlyData != null && this.selectedDate != null) {
      if (this.salesAreaBinding.length == 0) {
        this.salesAreaBinding = this.salesAreaList;
        //await this.getDataInit();
      }
      let selectedDate = new Date(this.selectedDate.year, this.selectedDate.month - 1, this.selectedDate.day);
      // Extract all unique years from the data
      const availableYears = this.extractAvailableYears();
      this.availableYears = ['All', ...availableYears];
      this.selectedYears = [2019, ...availableYears.slice(-2)];
      this.handleBapcSalesData(selectedDate);
    }
  }

  SaveOptionValueTemp(rollBack: boolean) {
    if (!rollBack) {
      window["monthlyTrendChannel"] = this.monthlyTrendChannel;
    } else {
      this.monthlyTrendChannel = window["monthlyTrendChannel"];
    }
  }
  onChangeCheckBox(event) {
    AnalyticsHelper.hanldeCheckBoxSelect(event);
  }

  onRemoveFilterYear($event) {
    if (this.selectedYears.length == 0) {
      this.selectedYears = ['All'];
      this.SaveOptionValueTemp(false);
      this.renderMonthlyTrendChart();
    }
    if ($event.value === 'All') {
      this.selectedYears = ['All'];
      return;
    }
  }

  onRemoveFilterMonthly($event) {
    if (this.monthlyTrendChannel.length == 0) {
      this.monthlyTrendChannel = ['All'];
      this.SaveOptionValueTemp(false);
      this.renderMonthlyTrendChart();
    }
    if ($event.value === 'All') {
      this.monthlyTrendChannel = [];
      return;
    }
    if (AnalyticsHelper.isSmddParent($event.value)) {
      var arrChilds = AnalyticsHelper.getSmddChild($event.value);
      this.monthlyTrendChannel = this.monthlyTrendChannel.filter(function (el) {
        return arrChilds.indexOf(el) < 0;
      });
    }
    if (AnalyticsHelper.isSmddChild($event.value)) {
      var parent = AnalyticsHelper.getSmddParent($event.value);
      this.monthlyTrendChannel = this.monthlyTrendChannel.filter(e => e !== parent);
    }
  }

  onAddFilterYear($event) {
    if ($event === 'All') {
      this.selectedYears = ['All'];
      return;
    } else {
      this.selectedYears = this.selectedYears.filter(e => e !== 'All');
    }
  }
  onAddFilterMonthly($event) {
    if ($event === 'All') {
      this.monthlyTrendChannel = ['All'];
      return;
    } else {
      this.monthlyTrendChannel = this.monthlyTrendChannel.filter(e => e !== 'All');
    }
    if (AnalyticsHelper.isSmddParent($event)) {
      var arrChilds = AnalyticsHelper.getSmddChild($event);
      this.monthlyTrendChannel = this.monthlyTrendChannel.filter(e => !arrChilds.includes(e));
    }
    if (AnalyticsHelper.isSmddChild($event)) {
      var parent = AnalyticsHelper.getSmddParent($event);
      var checkChildSelected = true;
      var arrChilds = AnalyticsHelper.getSmddChild(parent);
      arrChilds.forEach(child => {
        if (!this.monthlyTrendChannel.includes(child)) {
          checkChildSelected = false;
        }
      });
      if (checkChildSelected) {
        var arrTemp = [parent];
        this.monthlyTrendChannel = this.monthlyTrendChannel.filter(e => !arrChilds.includes(e));
        this.monthlyTrendChannel = arrTemp.concat(this.monthlyTrendChannel);
      } else {
        this.monthlyTrendChannel = this.monthlyTrendChannel.filter(e => e !== parent);
      }
    }
    if (!this.monthlyTrendChannel.some(x => x === 'All') && (this.monthlyTrendChannel.length + 1) == this.channels.length) {
      this.monthlyTrendChannel = ['All'];
    }
    var checkParentFilter = true;
    var filterNotCheck = this.channels.filter(e => !this.monthlyTrendChannel.includes(e.name) && e.name !== 'All');
    filterNotCheck.forEach(element => {
      if (!AnalyticsHelper.isSmddChild(element.name) || !this.monthlyTrendChannel.includes(AnalyticsHelper.getSmddParent(element.name))) {
        checkParentFilter = false;
      }
    });
    if (checkParentFilter) {
      this.monthlyTrendChannel = ['All'];
      return;
    }
  }

  /**
   * Extract all unique years from monthly data
   */
  private extractAvailableYears(): number[] {
    const years = new Set<number>();
    for (const row of this.monthlyData) {
      if (row.month && row.month.length >= 4) {
        const year = parseInt(row.month.substring(0, 4));
        if (!isNaN(year)) {
          years.add(year);
        }
      }
    }
    return Array.from(years).sort((a, b) => a - b);
  }

  /**
   * Create a data structure that supports dynamic years
   */
  private createYearDataStructure(availableYears: number[], includePerCase: boolean = false): any {
    const structure: any = {
      act: 0,
      bp: 0,
      ly: 0
    };

    // Add dynamic year properties
    availableYears.forEach(year => {
      structure[`ty${year}`] = 0;
      structure[`bp${year}`] = 0;
      structure[`ly${year}`] = 0;

      if (includePerCase) {
        structure[`perCase${year}`] = 0;
      }
    });

    if (includePerCase) {
      structure.perCase = 0;
      structure.perCaseBp = 0;
      structure.perCaseLy = 0;
    }

    return structure;
  }

  /**
   * Process data for a specific year
   */
  private processYearData(month: any, row: any, availableYears: number[]): void {
    const yearFromMonth = parseInt(row.month.substring(0, 4));

    // Since data is pre-filtered, we can directly process it
    const yearKey = `ty${yearFromMonth}`;
    const bpKey = `bp${yearFromMonth}`;
    const lyKey = `ly${yearFromMonth}`;

    if (month.nsr.hasOwnProperty(yearKey)) {
      month.nsr[yearKey] += parseFloat(row.nsr_ty);
      month.bapc[yearKey] += parseFloat(row.bapc_ty);
       if (row.regionCode != '9999') {
      month.nsr[bpKey] += parseFloat(row.nsr_bp);
      month.bapc[bpKey] += parseFloat(row.bapc_bp);
       }
      month.nsr[lyKey] += parseFloat(row.nsr_ly);
      month.bapc[lyKey] += parseFloat(row.bapc_ly);
    }

    // Always update the main BP field for the most recent year in availableYears
    if (availableYears.length > 0) {
      const mostRecentYear = Math.max(...availableYears);
      if (yearFromMonth === mostRecentYear && row.regionCode != '9999') {
        month.nsr.bp += parseFloat(row.nsr_bp);
        month.bapc.bp += parseFloat(row.bapc_bp);
      }
    }
  }

  /**
   * Process channel data for a specific year
   */
  private processChannelYearData(channel: any, row: any, availableYears: number[]): void {
    const yearFromMonth = parseInt(row.month.substring(0, 4));

    // Since data is pre-filtered, we can directly process it
    const yearKey = `ty${yearFromMonth}`;
    const bpKey = `bp${yearFromMonth}`;
    const lyKey = `ly${yearFromMonth}`;

    if (channel.nsr.hasOwnProperty(yearKey)) {
      channel.nsr[yearKey] += parseFloat(row.nsr_ty);
      channel.bapc[yearKey] += parseFloat(row.bapc_ty);
      if(row.regionCode != '9999'){
      channel.nsr[bpKey] += parseFloat(row.nsr_bp);
      channel.bapc[bpKey] += parseFloat(row.bapc_bp);
      }
      channel.nsr[lyKey] += parseFloat(row.nsr_ly);
      channel.bapc[lyKey] += parseFloat(row.bapc_ly);
    }

    // Always update the main BP field for the most recent year in availableYears
    if (availableYears.length > 0) {
      const mostRecentYear = Math.max(...availableYears);
      if (yearFromMonth === mostRecentYear && row.regionCode != '9999') {
        channel.nsr.bp += parseFloat(row.nsr_bp);
        channel.bapc.bp += parseFloat(row.bapc_bp);
      }
    }
  }

  /**
   * Process region data for a specific year
   */
  private processRegionYearData(region: any, row: any, availableYears: number[]): void {
    const yearFromMonth = parseInt(row.month.substring(0, 4));

    // Since data is pre-filtered, we can directly process it
    const yearKey = `ty${yearFromMonth}`;
    const bpKey = `bp${yearFromMonth}`;
    const lyKey = `ly${yearFromMonth}`;

    if (region.nsr.hasOwnProperty(yearKey)) {
      region.nsr[yearKey] += parseFloat(row.nsr_ty);
      region.bapc[yearKey] += parseFloat(row.bapc_ty);
      region.nsr[bpKey] += parseFloat(row.nsr_bp);
      region.bapc[bpKey] += parseFloat(row.bapc_bp);
      region.nsr[lyKey] += parseFloat(row.nsr_ly);
      region.bapc[lyKey] += parseFloat(row.bapc_ly);
    }

    // Always update the main BP field for the most recent year in availableYears
    if (availableYears.length > 0) {
      const mostRecentYear = Math.max(...availableYears);
      if (yearFromMonth === mostRecentYear) {
        region.nsr.bp += parseFloat(row.nsr_bp);
        region.bapc.bp += parseFloat(row.bapc_bp);
      }
    }
  }

  /**
   * Calculate perCase for dynamic years
   */
  private calculatePerCaseForYears(nsr: any, bapc: any, availableYears: number[]): void {
    // Calculate standard perCase values
    let perCase = AnalyticsHelper.calcPerCase(nsr, bapc);
    nsr.perCase = parseFloat((perCase.act / 1000).toFixed(2));
    nsr.perCaseBp = parseFloat((perCase.bp / 1000).toFixed(2));
    nsr.perCaseLy = parseFloat((perCase.ly / 1000).toFixed(2));

    // Calculate perCase for each available year
    availableYears.forEach(year => {
      const yearKey = `ty${year}`;
      const bpKey = `bp${year}`;
      const lyKey = `ly${year}`;
      const perCaseKey = `perCase${year}`;

      if (nsr.hasOwnProperty(yearKey)) {
        const yearPerCase = AnalyticsHelper.calcPerCase({
          act: nsr[yearKey],
          bp: nsr[bpKey],
          ly: nsr[lyKey]
        }, {
          act: bapc[yearKey],
          bp: bapc[bpKey],
          ly: bapc[lyKey]
        });
        nsr[perCaseKey] = parseFloat((yearPerCase.act / 1000).toString());
      }
    });
  }

  /**
   * Build chart series dynamically based on available years
   */
  private buildChartSeries(availableYears: number[], currentYear: number): any[] {
    const series = [];

    availableYears = availableYears.sort((a, b) => a - b);
    // Add series for each available year (excluding current year and last year)
    const otherYears = availableYears.slice(0, -1);
    otherYears.forEach(year => {
      series.push({
        name: year.toString(),
        data: [],
        type: 'line'
      });
    });

    // Add current year series
    series.push({
      name: `${availableYears[availableYears.length - 1]}`,
      data: [],
      type: 'column'
    });

    // Only show BP data when current year is selected
    const isCurrentYearSelected = availableYears.includes(currentYear);

    if (isCurrentYearSelected) {
      series.push({
        name: 'ST ' + currentYear,
        data: [],
        type: 'area'
      });
    }

    return series;
  }

  /**
   * Get data for a specific year from the data structure
   */
  private getYearData(data: any, year: number, currentYear: number): number {
    const yearKey = `ty${year}`;
    if (data.hasOwnProperty(yearKey)) {
      return parseFloat((data[yearKey] / 1000).toFixed(0) == "0" ? (data[yearKey] / 1000).toFixed(2) : (data[yearKey] / 1000).toFixed(0));
    }
    return 0;
  }

  /**
   * Aggregate channel data dynamically for all years
   */
  private aggregateChannelData(channelTemp: any, sourceData: any, availableYears: number[]): void {
    // Aggregate standard fields
    channelTemp.nsr.act += parseFloat(sourceData.nsr.act);
    channelTemp.nsr.bp += parseFloat(sourceData.nsr.bp);
    channelTemp.bapc.act += parseFloat(sourceData.bapc.act);
    channelTemp.bapc.bp += parseFloat(sourceData.bapc.bp);
    channelTemp.nsr.ly += parseFloat(sourceData.nsr.ly);
    channelTemp.bapc.ly += parseFloat(sourceData.bapc.ly);

    // Aggregate dynamic year fields
    availableYears.forEach(year => {
      const yearKey = `ty${year}`;
      const bpKey = `bp${year}`;
      const lyKey = `ly${year}`;

      if (sourceData.nsr.hasOwnProperty(yearKey)) {
        channelTemp.nsr[yearKey] += parseFloat(sourceData.nsr[yearKey]);
        channelTemp.bapc[yearKey] += parseFloat(sourceData.bapc[yearKey]);
        channelTemp.nsr[bpKey] += parseFloat(sourceData.nsr[bpKey]);
        channelTemp.bapc[bpKey] += parseFloat(sourceData.bapc[bpKey]);
        channelTemp.nsr[lyKey] += parseFloat(sourceData.nsr[lyKey]);
        channelTemp.bapc[lyKey] += parseFloat(sourceData.bapc[lyKey]);
      }
    });
  }

  handleBapcSalesData(selectedDate: Date) {
    let months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    let salesTrends = [];
    const currentYear = this.selectedDate.year;

    let availableYears = this.selectedYears.filter(x => x !== 'All');
    if (this.selectedYears.some(x => x == 'All')) {
      availableYears = this.availableYears.filter(x => x !== 'All');
    }

    // Filter monthlyData to only include rows for selected years - Performance optimization
    const filteredMonthlyData = this.monthlyData.filter(row => {
      if (row.month && row.month.length >= 4) {
        const yearFromMonth = parseInt(row.month.substring(0, 4));
        return availableYears.includes(yearFromMonth);
      }
      return false;
    });

    this.channelLev3codetoRegioncode = {};
    for (let i = 0; i < filteredMonthlyData.length; i++) {
      let row = filteredMonthlyData[i];
      if (row.channelCode != '' && !(row.channelCode in this.channelLev3codetoRegioncode)) {
        this.channelLev3codetoRegioncode[row.channelCode] = [];
      }

      if (row.channelCode != '' && !this.channelLev3codetoRegioncode[row.channelCode].includes(row.regionCode) && this.salesAreaList.some(s => s.cd == row.regionCode)) {
        if (parseFloat(row.nsr_ty) != 0 || parseFloat(row.bapc_ty) != 0 || (row.month.includes(currentYear) && parseFloat(row.nsr_bp) != 0) || (row.month.includes(currentYear) && parseFloat(row.bapc_bp) != 0)) {
          this.channelLev3codetoRegioncode[row.channelCode].push(row.regionCode);
        }
      }

      let monthName = months[parseInt(row.month.substring(4, 6)) - 1];
      let month = salesTrends.find(x => x.month == monthName);
      if (month == null) {
        month = {
          month: monthName,
          index: parseInt(row.month.substring(4, 6)) - 1,
          bapc: this.createYearDataStructure(availableYears),
          nsr: this.createYearDataStructure(availableYears, true),
          channels: []
        };
        salesTrends.push(month);
      }

      // Process data for the specific year
      this.processYearData(month, row, availableYears);

      // [FPT-ThinhLD4][1204061681619804] Dashboard Channel filter update
      let currentChannels = AnalyticsHelper.ChannelLv2();
      currentChannels.push({
        code: [41, 51],
        channel: 'Alcohol',
        level: 1,
        region: ['7200', '9100']
      });

      currentChannels = currentChannels.filter(x => x.code.find(y => row.channelCode.indexOf(y) == 0) != null && (!x.region || x.region.includes(row.regionCode)));
      // if(row.channelCode.indexOf('33') ==0 && row.month.substring(0, 4) == '2023'  && row.bapc_ty > 0)
      // {
      //   debugger;
      // }
      //remove alcohol because it is of other
      if (row.channelCode == '411' && row.regionCode == '9100') {
        currentChannels = currentChannels.filter(item => item.channel !== 'Alcohol');
      }
      for (var j = 0; j < currentChannels.length; j++) {
        let currentChannel = currentChannels[j];
        let channel = month.channels.find(x => x.channel == currentChannel.channel);
        if (channel == null) {
          channel = {
            channel: currentChannel.channel,
            bapc: this.createYearDataStructure(availableYears),
            nsr: this.createYearDataStructure(availableYears, true),
            regions: []
          };
          month.channels.push(channel);
        }
        //handle region code except 7100 (7100 will be handled after)
        if (!channel.regions.some(x => x.regionCode == row.regionCode) && row.regionCode != '7100') {
          let region = {
            regionCode: row.regionCode,
            bapc: this.createYearDataStructure(availableYears),
            nsr: this.createYearDataStructure(availableYears, true)
          };

          this.processRegionYearData(region, row, availableYears);
          channel.regions.push(region);
        }
        else if (row.regionCode != '7100') {
          let region = channel.regions.find(x => x.regionCode == row.regionCode);
          this.processRegionYearData(region, row, availableYears);
        }


        //only cvs  has customer development division that has region code 7100
        if ((channel.channel == 'CVS' || channel.channel == 'eCommerce') && row.regionCode != '9100' && row.regionCode != '9200') {
          if (channel.regions.some(x => x.regionCode == '7100')) {
            let region_7100 = channel.regions.find(x => x.regionCode == '7100');
            if (channel.channel == 'eCommerce') {
              // For eCommerce channel, process all filtered data
              this.processRegionYearData(region_7100, row, availableYears);
            } else {
              this.processRegionYearData(region_7100, row, availableYears);
            }

          }
          else {
            let region_7100 = {
              regionCode: '7100',
              bapc: this.createYearDataStructure(availableYears),
              nsr: this.createYearDataStructure(availableYears, true)
            };

            this.processRegionYearData(region_7100, row, availableYears);
            channel.regions.push(region_7100);
          }
        }

        // if (channel.channel == 'eCommerce' && row.regionCode == '9200')
        //   {
        //     if (channel.regions.some(x => x.regionCode == '9200'))
        //     {
        //       let region_9200 = channel.regions.find(x =>  x.regionCode == '9200');
        //       if (row.month.indexOf(currentYear) == 0) {
        //         region_9200.nsr.act += parseFloat(row.nsr_ty);
        //         region_9200.nsr.bp += parseFloat(row.nsr_bp);
        //         region_9200.bapc.act += parseFloat(row.bapc_ty);
        //         region_9200.bapc.bp += parseFloat(row.bapc_bp);
        //       } else if (row.month.indexOf(lastYear) == 0) {
        //         region_9200.nsr.ly += parseFloat(row.nsr_ty);
        //         region_9200.bapc.ly += parseFloat(row.bapc_ty);
        //       } else {
        //         region_9200.nsr.ty2019 += parseFloat(row.nsr_ty);
        //         region_9200.bapc.ty2019 += parseFloat(row.bapc_ty);
        //         region_9200.nsr.bp2019 += parseFloat(row.nsr_bp);
        //         region_9200.bapc.bp2019 += parseFloat(row.bapc_bp);
        //         region_9200.nsr.ly2019 += parseFloat(row.nsr_ly);
        //         region_9200.bapc.ly2019 += parseFloat(row.bapc_ly);
        //       }
        //     }
        //     else
        //     {
        //       let region_9200 = {
        //         regionCode: '9200',
        //         bapc: {
        //           act: 0,
        //           bp: 0,
        //           ty2019: 0,
        //           bp2019: 0,
        //           ly2019: 0,
        //           ly: 0
        //         },
        //         nsr: {
        //           act: 0,
        //           bp: 0,
        //           ty2019: 0,
        //           bp2019: 0,
        //           ly2019: 0,
        //           ly: 0,
        //           perCase: 0,
        //           perCaseBp: 0,
        //           perCaseLy: 0,
        //           perCase2019: 0
        //         }
        //       };

        //       if (row.month.indexOf(currentYear) == 0) {
        //         region_9200.nsr.act = parseFloat(row.nsr_ty);
        //         region_9200.nsr.bp = parseFloat(row.nsr_bp);
        //         region_9200.bapc.act = parseFloat(row.bapc_ty);
        //         region_9200.bapc.bp = parseFloat(row.bapc_bp);
        //       } else if (row.month.indexOf(lastYear) == 0) {
        //         region_9200.nsr.ly = parseFloat(row.nsr_ty);
        //         region_9200.bapc.ly = parseFloat(row.bapc_ty);
        //       } else {
        //         region_9200.nsr.ty2019 = parseFloat(row.nsr_ty);
        //         region_9200.bapc.ty2019 = parseFloat(row.bapc_ty);
        //         region_9200.nsr.bp2019 = parseFloat(row.nsr_bp);
        //         region_9200.bapc.bp2019 = parseFloat(row.bapc_bp);
        //         region_9200.nsr.ly2019 = parseFloat(row.nsr_ly);
        //         region_9200.bapc.ly2019 = parseFloat(row.bapc_ly);
        //       }
        //       channel.regions.push(region_9200);
        //     }
        //   }
        if (channel.channel == 'eCommerce' && row.regionCode == '7100') {
          // For eCommerce channel with region 7100, process all filtered data
          this.processChannelYearData(channel, row, availableYears);
        } else {
          this.processChannelYearData(channel, row, availableYears);
        }
      }
    }

    // Xóa '7100' khỏi key 331 of ecomerce chuyen doi tu channer eCommerce
    this.channelLev3codetoRegioncode[331] = this.channelLev3codetoRegioncode[331].filter(function (item) {
      return item !== '7100';
    });

    // Xóa '7100' khỏi key 332 of ecomerce chuyen doi tu channer eCommerce
    this.channelLev3codetoRegioncode[332] = this.channelLev3codetoRegioncode[332].filter(function (item) {
      return item !== '7100';
    });


    for (let i = 0; i < salesTrends.length; i++) {
      let salesTrend = salesTrends[i];
      this.calculatePerCaseForYears(salesTrend.nsr, salesTrend.bapc, availableYears);

      for (let j = 0; j < salesTrend.channels.length; j++) {
        let channel = salesTrend.channels[j];
        this.calculatePerCaseForYears(channel.nsr, channel.bapc, availableYears);

        for (let k = 0; k < channel.regions.length; k++) {
          let region = channel.regions[k];
          this.calculatePerCaseForYears(region.nsr, region.bapc, availableYears);
        }
      }


    }
    //get full region have tyyear = 0
    const zeroRegionsByChannel = {};
    this.selectedYears;
    const nowYear = new Date().getFullYear();
    salesTrends.forEach(month => {
      month.channels.forEach(channel => {
        channel.regions.forEach(region => {
          const { regionCode, bapc, gp } = region;
          let isZeroBp = true;
          if (this.selectedYears.some(x => x == 'All')) {
            // if(regionCode == '4000' && channel.channel == 'Food'){
            //   debugger
            // }
            let availableYears = this.availableYears.filter(x => x != 'All');
            availableYears.forEach(element => {
              let tmp = parseFloat((bapc[`ty${element}`] / 1000).toFixed(2));
              let tmpBp2025 = parseFloat((bapc[`bp${nowYear}`] / 1000).toFixed(2));

              if (tmp != 0 || tmpBp2025 != 0) {
                isZeroBp = false;
              }
            });
          }
          else {
            this.selectedYears.forEach(element => {
              let tmp = parseFloat((bapc[`ty${element}`] / 1000).toFixed(2));
              let tmpBp2025 = 0;
              if (this.selectedYears.includes(nowYear)) {
                 tmpBp2025 = parseFloat((bapc[`bp${nowYear}`] / 1000).toFixed(2));
              }
              if (tmp != 0 || tmpBp2025 != 0) {
                isZeroBp = false;
              }
            });
          }
          if (!zeroRegionsByChannel[channel.channel]) {
            zeroRegionsByChannel[channel.channel] = {};
          }

          if (!zeroRegionsByChannel[channel.channel][regionCode]) {
            zeroRegionsByChannel[channel.channel][regionCode] = {
              isGreatZeroBp: false,
            };
          }
          if (!isZeroBp) zeroRegionsByChannel[channel.channel][regionCode].isGreatZeroBp = true;
        });
      }
      );
    });
    const fullyZeroRegionsBp = Object.entries(zeroRegionsByChannel).map(
      ([channel, regions]) => ({
        channel,
        regions: Object.entries(regions)
          .filter(([_, stats]) => !stats.isGreatZeroBp)
          .map(([regionCode]) => regionCode)
      })
    );
    window['fullyZeroRegionsBp'] = fullyZeroRegionsBp;

    salesTrends.sort((a, b) => a.index > b.index ? 1 : -1);
    window['monthlyTrendAgg'] = salesTrends;
    this.renderMonthlyTrendChart();
  }
  renderMonthlyTrendChart() {
    if (this.monthlyTrendChannel.length == 0) {
      this.monthlyTrendChannel = ["All"]
    }
    if (this.bapcMonthlyTrendChart != null) {
      this.bapcMonthlyTrendChart.destroy();
    }
    let monthlyTrendAgg = window['monthlyTrendAgg'];
    let categories = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    let allColors = ['#F40009', '#C877DB', '#5FB0FF', '#BAFECC', '#0000FF',
      '#00FF00', '#6e24f8ff', '#FFC0CB', '#FFA500',
      '#A52A2A', '#800000', '#808080', '#C0C0C0', '#008000', '#808000',
      '#7FFD4', '#000000', '#FFFFFF'];

    // Build series dynamically based on available years
    let availableYears = this.selectedYears.filter(x => x !== 'All');
    if (this.selectedYears.some(x => x == 'All')) {
      availableYears = this.availableYears.filter(x => x != 'All');
    }
    let series = this.buildChartSeries(availableYears, this.selectedDate.year);

    // Create width array with length equal to number of years
    const width = new Array(availableYears.length).fill(5);

    // Create opacity array with length equal to number of years
    const opacity = new Array(availableYears.length).fill(1);

    let colors = [];
    for (var i = 0; i < series.length; i++) {
      colors.push(allColors[i]);
    }
    for (var i = 0; i < monthlyTrendAgg.length; i++) {
      // FPT-HoiLT2:  [2022/10/25][SENSE][1203222980629285] SENSE dashboard QA (latest day KPI as well as trends)
      let channelTemp = {
        bapc: this.createYearDataStructure(availableYears),
        nsr: this.createYearDataStructure(availableYears, true)
      };
      let monthlyTrend = monthlyTrendAgg[i];
      let dataValues: any = {
        bapc: monthlyTrend.bapc,
        nsr: monthlyTrend.nsr
      };

      if (this.monthlyTrendChannel.some(channel => channel == 'All') && this.salesArea.some(s => s.name == 'All')) {
        // Use monthly trend data directly (already set above)
      }
      else {
        if (this.monthlyTrendChannel.some(channel => channel == 'All')) {
          this.salesArea.forEach(regionSelected => {
            monthlyTrend.channels.forEach(channel => {
              channel.regions.forEach(region => {
                if (regionSelected.cd == region.regionCode) {

                  //SMDD, Vending and Retail, Food were already sum
                  if (channel.channel == "SM" || channel.channel == "D&D" || channel.channel == "Vending_FS" || channel.channel == "Vending_REG"
                    || channel.channel == "Retail/Food") {
                    return;
                  }
                  this.aggregateChannelData(channelTemp, region, availableYears);
                }
              })
            })
          })
        }
        else if (this.salesArea.some(x => x.cd == 'All')) {
          this.monthlyTrendChannel.forEach(channelname => {
            monthlyTrend.channels.forEach(channel => {
              if (channel.channel == channelname) {
                this.aggregateChannelData(channelTemp, channel, availableYears);
              }
            })
          })
        }
        else {
          this.salesArea.forEach(regionSelected => {
            this.monthlyTrendChannel.forEach(channelSelected => {
              monthlyTrend.channels.forEach(channel => {
                channel.regions.forEach(region => {
                  if (channel.channel == channelSelected && region.regionCode == regionSelected.cd) {
                    this.aggregateChannelData(channelTemp, region, availableYears);
                  }
                })
              })
            })
          })
        }
      }

      // Set dataValues to use channelTemp if filtering is applied
      if (this.monthlyTrendChannel.some(channel => channel != 'All') || this.salesArea.some(region => region.cd != 'All')) {
        this.calculatePerCaseForYears(channelTemp.nsr, channelTemp.bapc, availableYears);
        dataValues = {
          bapc: channelTemp.bapc,
          nsr: channelTemp.nsr
        };
      }

      let seriesIndex = 0;

      // Add data for other years
      availableYears.forEach(year => {
        const yearData = this.getYearData(dataValues.bapc, year, this.selectedDate.year);
        series[seriesIndex].data.push(yearData);
        seriesIndex++;
      });

      // Add BP data only when current year is selected
      const currentYear = this.selectedDate.year;
      const isCurrentYearSelected = availableYears.includes(currentYear);

      if (isCurrentYearSelected) {
        const bpData = parseFloat((dataValues.bapc.bp / 1000).toFixed(0) == "0" ? (dataValues.bapc.bp / 1000).toFixed(2) : (dataValues.bapc.bp / 1000).toFixed(0));
        series[seriesIndex].data.push(bpData);
      }
    }

    // Remove series for years that don't exist in the data
    // const otherYears = availableYears.filter(year => year !== this.selectedDate.year && year !== this.selectedDate.year - 1);
    // const seriesToRemove = [];

    // // Check if we need to remove any series based on available data
    // for (let i = 0; i < otherYears.length; i++) {
    //   const year = otherYears[i];
    //   const hasData = series[i].data.some(value => value !== null && value !== 0);
    //   if (!hasData) {
    //     seriesToRemove.push(i);
    //   }
    // }

    // // Remove series in reverse order to maintain indices
    // seriesToRemove.reverse().forEach(index => {
    //   series.splice(index, 1);
    //   colors.splice(index, 1);
    // });
    // min = min - 100;
    series = series.filter(s => {
      const sum = s.data.reduce((a, b) => a + b, 0);
      return sum !== 0;
    });


    if (series.length === 0) {
      series = [{
        name: 'No Data',
        data: []
      }];
    }
    let t = this;
    const options = {
      chart: {
        height: 310,
        type: 'line',
        zoom: {
          enabled: false
        },
        toolbar: {
          show: true,
          tools: {
            download: ''
          },
          export: {
            csv: {
              headerCategory: 'Month'
            }
          }
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        width: width,
        curve: 'smooth'
      },
      plotOptions: {
        bar: {
          columnWidth: '40%'
        }
      },
      colors: colors,
      series: series,
      fill: {
        opacity: opacity,
        gradient: {
          inverseColors: false,
          shade: 'light',
          type: "vertical",
          opacityFrom: 0.85,
          opacityTo: 0.55,
          stops: [0, 100, 100, 100, 100]
        }
      },
      labels: categories,
      markers: {
        size: 0
      },
      xaxis: {
        type: 'text'
      },
      yaxis: {
        labels: {
          formatter: function (val: number) {
            return AnalyticsHelper.formatNumber(val);
          }
        },
        //min: 0,
        forceNiceScale: true
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter: function (val) {
            if (typeof val !== "undefined") {
              return AnalyticsHelper.formatNumber(val);
            }
            return val;
          }
        }
      },
      legend: {
        offsetY: 0,
        labels: {
          useSeriesColors: false
        }
      }
    }

    document.querySelector(`#${this.chartId}`).innerHTML = '';

    this.bapcMonthlyTrendChart = new ApexCharts(
      document.querySelector(`#${this.chartId}`),
      options
    );
    this.bapcMonthlyTrendChart.render();
    setTimeout(() => {
      t.ready.emit(true);
    });
  }

  public isSmddChild(channel: string) {
    if (channel == "SM" || channel == "Drug" || channel == "Discounter" || channel == "D&D") {
      return true;
    }
    // [FPT-HoiLT][1204061681619804] Dashboard Channel filter update
    if (channel == "Retail" || channel == "Food") {
      return true;
    }
    return false;
  }

  onRemoveFilterSalesArea($event) {
    if (this.salesArea.length == 0) {
      this.salesArea = [ALL_OBJ];
      return;
    }
  }

  onAddFilterSalesArea($event) {
    if ($event.cd === ALL_OBJ.cd) {
      this.salesArea = [ALL_OBJ];
      return;
    }
    this.salesArea = this.salesArea.filter(e => e.cd !== ALL_OBJ.cd);
  }

  setSalesArea() {
    this.salesArea = this.aggregatedSalesArea;
  }

  SalesAreaAggregate() {
    this.aggregatedSalesArea = this.salesArea;
    this.salesDistrict = [ALL_OBJ];
    this.salesDistrictBinding = this.salesDistrictList;
    this.aggregatedSalesDistrict = [ALL_OBJ];
    this.renderMonthlyTrendChart();
    //this.bindingSalesDistrictData();
  }

  onCloseSalesArea() {
    this.salesArea = this.aggregatedSalesArea;
  }

  bindingSalesDistrictData() {
    if (!this.salesArea.some(x => x.name === "All")) {
      this.salesDistrict = [ALL_OBJ];
      this.salesDistrictBinding = [ALL_OBJ];
      this.salesArea.forEach(x => {
        var district_names = this.sales_area_to_sales_district[x.name];
        this.salesDistrictList.filter(d => district_names.includes(d.name)).forEach(s => {
          if (!this.salesDistrictBinding.some(x => x.name === s.name)) {
            this.salesDistrictBinding.push(s);
          }
        });
      })
    }
  }

  onRemoveFilterSalesDistrict($event) {
    if (this.salesDistrict.length == 0) {
      this.salesDistrict = [ALL_OBJ];
      return;
    }
  }

  onAddFilterSalesDistrict($event) {
    if ($event.cd === ALL_OBJ.cd) {
      this.salesDistrict = [ALL_OBJ];
      return;
    }
    this.salesDistrict = this.salesDistrict.filter(e => e.cd !== ALL_OBJ.cd);
  }

  setSalesDistrict() {
    this.salesDistrict = this.aggregatedSalesDistrict;
  }

  SalesDistrictAggregate() {
    this.aggregatedSalesDistrict = this.salesDistrict;
  }

  onCloseSalesDistrict() {
    this.salesDistrict = this.aggregatedSalesDistrict;
  }

  YearAggregate() {
    let selectedDate = new Date(this.selectedDate.year, this.selectedDate.month - 1, this.selectedDate.day);
    this.handleBapcSalesData(selectedDate);
    this.ChannelAggregate();
  }

  getDistinctRegionCodes(): string[] {
    const distinctRegions = new Set<string>();

    // Iterate through all values in channelLev3codetoRegioncode
    for (const channelCode in this.channelLev3codetoRegioncode) {
      if (this.channelLev3codetoRegioncode.hasOwnProperty(channelCode)) {
        const regionCodes = this.channelLev3codetoRegioncode[channelCode];
        if (Array.isArray(regionCodes)) {
          regionCodes.forEach(regionCode => {
            distinctRegions.add(regionCode);
          });
        }
      }
    }

    return Array.from(distinctRegions);
  }

  ChannelAggregate() {
    this.aggregatedSalesArea = [ALL_OBJ];
    this.salesArea = this.aggregatedSalesArea;
    var code_list = [];
    var regionCode_binding = [];
    if (this.monthlyTrendChannel.some(x => x != 'All')) {
      this.monthlyTrendChannel.forEach(channel => {

        var codes = this.channels.filter(x => x.name == channel)[0].code;
        codes.forEach(c => {
          if (!code_list.includes(c)) {
            code_list.push(c);
          }
        })
      });


      code_list.forEach(code => {
        for (var channelCode in this.channelLev3codetoRegioncode) {
          if (channelCode.indexOf(code) == 0) {
            this.channelLev3codetoRegioncode[channelCode].forEach(x => {
              if ((channelCode == "411" || channelCode == "511") && this.monthlyTrendChannel.some(channel => channel == "Alcohol") && this.monthlyTrendChannel.some(channel => channel == "Others")) {
                if (!regionCode_binding.includes("7200")) {
                  regionCode_binding.push("7200");
                }
                if (!regionCode_binding.includes("9100")) {
                  regionCode_binding.push("9100");
                  return;
                }
              }
              if ((channelCode == "411" || channelCode == "511") && this.monthlyTrendChannel.some(channel => channel == "Alcohol")) {
                if (!regionCode_binding.includes("7200")) {
                  regionCode_binding.push("7200");
                  return;
                }

                if (channelCode == "511" && !regionCode_binding.includes("9100")) {
                  regionCode_binding.push("9100");
                  return;
                }
              }
              else if ((channelCode == "411" || channelCode == "511") && this.monthlyTrendChannel.some(channel => channel == "Others")) {
                if (!regionCode_binding.includes("9100")) {
                  regionCode_binding.push("9100");
                  return;
                }
              }
              else if (!regionCode_binding.includes(x)) {
                regionCode_binding.push(x);
              }
            })
          }
        }
      })
      //remove region have 12 ty[year] = 0 
      const allZeroRegionCodesBp = window['fullyZeroRegionsBp'];
      const mapZeroReions = allZeroRegionCodesBp.map(
        ({ channel, regions }) => {
          const hasVending = this.monthlyTrendChannel.includes(channel);
          if (hasVending) {
            return {
              channel,
              regions: regions
            }
          }
          else {
            return null;
          }
        }
      ).filter(item => item !== null);
      const intersection = mapZeroReions
        .map(item => item.regions)
        .reduce((a, b) => a.filter(code => b.includes(code)));
        //  this.salesAreaBinding = [ALL_OBJ, ...this.salesAreaList.filter(x => regionCode_binding.includes(x.cd) && !intersection.includes(x.cd))];
      this.salesAreaBinding = [ALL_OBJ, ...this.salesAreaList.filter(x => regionCode_binding.includes(x.cd))];
    }
    else {
      let regionCodesArray = this.getDistinctRegionCodes();
      this.salesAreaBinding = this.salesAreaList.filter(x => x.cd == "All" || regionCodesArray.includes(x.cd));
    }
    this.renderMonthlyTrendChart();
  }

  downloadPng() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    this.bapcMonthlyTrendChart["exports"]?.dataURI().then((res) => {
      if ("imgURI" in res) {
        const { imgURI } = res;
        const link = document.createElement('a');
        link.href = imgURI;
        link.download = `BAPCMonthly_${year}-${month}-${day}`;
        link.click();
      }
    })
  }

  downloadCSV() {
    this.bapcMonthlyTrendChart["exports"]?.exportToCSV({
      series: this.bapcMonthlyTrendChart['w']['config']['series'],
      columnDelimiter: this.bapcMonthlyTrendChart['w'].config.chart.toolbar.export.csv.columnDelimiter,
      fileName: 'BAPCMonthly_' + this.selectedDate.year + '-' + this.selectedDate.month + '-' + this.selectedDate.day
    });
  }

}
